import React, { useState, useEffect, useContext } from 'react';
import {
  Box,
  Button,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Typography,
  Paper,
  Menu
} from '@mui/material';
import { Divider } from '@mui/material';
import { ReactComponent as GenerateButton } from '../../../images/generateButton.svg';
import { ExpandMore } from '@mui/icons-material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useNavigate, useLocation } from 'react-router-dom';
import { validateGitCredentials } from '../../../services/webServices';
import { LoadingModalContext } from '../../main-pages/ServicePage';
import { set } from 'date-fns';
import BrowsePathPopup from './BrowsePathPopup';


function GithubConfigurationForm() {
  const [repositoryUrl, setRepositoryUrl] = React.useState('');
  const [username, setUsername] = React.useState('');
  const [token, setToken] = React.useState('');
  const [repoName, setRepoName] = React.useState('');
  const [reviewerEmail, setReviewerEmail] = React.useState('');
  const [showBranchDropdown, setShowBranchDropdown] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState('');
  const [projectType, setProjectType] = useState('');
  const [branches, setBranches] = useState([]);
  const [framework, setFramework] = useState("");
  const [popUpOpen, setPopUpOpen] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");

  const navigate = useNavigate();
  const location = useLocation();
  const { setLoadingState } = useContext(LoadingModalContext);

  useEffect(() => {
    console.log("=== GitCredentialsPage useEffect ===");
    console.log("Full location.state:", location.state);
    console.log("Received framework:", location.state?.framework);
    console.log("Received project type:", location.state?.projectType);

    // Set state from location
    setProjectType(location.state?.projectType || '');
    setFramework(location.state?.framework || '');

    // Validate required navigation parameters
    if (!location.state?.framework) {
      console.error("Missing framework in navigation state. User may have accessed this page directly.");
    }

    if (!location.state?.projectType) {
      console.error("Missing project type in navigation state. User may have accessed this page directly.");
    }
  }, [
    location.state?.projectType,
    location.state?.framework,
  ]);

  const handleValidateClick = async () => {
    setLoadingState({ open: true, message: "Validating Credentials", progress: null });

    try {

      const formdata = {
        repositoryUrl: repositoryUrl,
        username: username,
        token: token,
        repoName: repoName,
        reviewerEmail: reviewerEmail,
      };
      console.log("Form Data: ", formdata);
      const reponse = await validateGitCredentials({ formdata });
      console.log("Response: ", reponse);
      console.log("Branches: ", reponse.data.branches);
      if (reponse.data.success) {
        console.log("Branches: ", reponse.data.branches);
        setBranches(reponse.data.branches);
        setStatusMessage("Credentials validated successfully.");
        setShowBranchDropdown(true);
      }


    } catch (error) {
      console.error('Error validating credentials:', error);
      setStatusMessage("Error validating credentials. Please check your inputs.");
      setLoadingState({ open: false, message: "", progress: null });
    } finally {
      // setLoading(false);
      setLoadingState({ open: false, message: "", progress: null });
    }
  };

  const handleConfirmClick = () => {
    const gitCredentails = {
      repositoryUrl: repositoryUrl,
      username: username,
      token: token,
      repoName: repoName,
      reviewerEmail: reviewerEmail,
      selectedBranch: selectedBranch,
    };



    console.log("Selected Branch: ", selectedBranch);
    const gitCredentials = {
      repositoryUrl: repositoryUrl,
      username: username,
      token: token,
      repoName: repoName,
      reviewerEmail: reviewerEmail,
      selectedBranch: selectedBranch
    };
    console.log("Git Credentials from git page: ", gitCredentials);
    navigate(`/dashboard/test-automation/${framework}/${projectType}`, {
      state: {
        SelectedBranch: selectedBranch,
        framework: framework,
        projectType: projectType,
        gitCredentials: gitCredentials
      }
    });

  }
  const handleClose = () => {
    setPopUpOpen(false);
  }


  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      bgcolor="#f7f4f2"
    >
      <Paper elevation={1} sx={{ p: 3, width: 500 }}>
        {/* GitHub Configuration Header */}
        <Box mb={2}>
          <Typography variant="subtitle1" fontWeight={500}>
            <ExpandMore sx={{ mr: 1, verticalAlign: 'text-bottom' }} />
            Github Configuration
          </Typography>
        </Box>

        {/* Form Fields */}
        <Box display="flex" flexDirection="column" gap={2}>
          <TextField
            fullWidth
            label="Repository Url"
            placeholder="https://example.com"
            value={repositoryUrl}
            onChange={(e) => setRepositoryUrl(e.target.value)}
            variant="outlined"
          />
          {/* <TextField
            fullWidth
            label="Username"
            placeholder="Name"
            variant="outlined"
            autoComplete="new-username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          /> */}
          <TextField
            fullWidth
            label="Token (PAT)"
            placeholder="Key"
            type='password'
            variant="outlined"
            autoComplete="new-password"
            value={token}
            onChange={(e) => setToken(e.target.value)}
          />
          {/* <TextField
            fullWidth
            label="Project Name"
            placeholder="Project Name"
            variant="outlined"
            value={repoName}
            onChange={(e) => setRepoName(e.target.value)}
          /> */}


          <Box mt={1.5} textAlign="left">
            {/* {!showBranchDropdown && (

              <Typography variant="subtitle1" fontWeight={500} >
                <ChevronRightIcon sx={{ mr: 1, verticalAlign: 'text-bottom' }} />
                GitHub Configuration</Typography>
            )} */}
            <Button
              variant="contained"
              sx={{ backgroundColor: '#4CAF50', color: 'white', mt: 2, textTransform: 'none' }}
              disabled={!repositoryUrl || !token}
              onClick={handleValidateClick}
            >
              Validate Credentials
            </Button>
            <Typography type="subtitle" sx={{ mt: 2 }}>{statusMessage}</Typography>
            {showBranchDropdown && (
              <Box mt={2} mb={2}>
                <FormControl fullWidth>
                  <InputLabel>Select Branch</InputLabel>
                  <Select
                    value={selectedBranch}
                    label="Select Branch"
                    onChange={(e) => setSelectedBranch(e.target.value)}
                  >

                    {branches.map((branch) => (
                      <MenuItem key={branch} value={branch}>
                        {branch}
                      </MenuItem>
                    ))}

                  </Select>
                </FormControl>
                <TextField
                  fullWidth
                  label="PR Reviewer Email ID (Optional)"
                  placeholder="Email ID"
                  variant="outlined"
                  value={reviewerEmail}
                  onChange={(e) => setReviewerEmail(e.target.value)}
                  sx={{ mt: 2, }}
                />
              </Box>
            )}
          </Box>
        </Box>
        <Divider sx={{
          my: 1.5,
          width: '100%',
        }} />
        {/* Confirm Button */}
        <Box mt={1} textAlign="right" mb={0}>
          <Button
            startIcon={<GenerateButton />}
            variant="contained"
            sx={{ textTransform: 'none', }}
            onClick={handleConfirmClick}
            disabled={!selectedBranch} // Disable if no branch is selected
          >
            Confirm
          </Button>
        </Box>
      </Paper>
      <BrowsePathPopup open={popUpOpen} handleClose={handleClose} text1={"Congratulations! Your Robot Framework project has been successfully updated."} />
    </Box>
  );
}

export default GithubConfigurationForm;